import React from 'react';
import PropTypes from 'prop-types';
import cn from '../utils/cn';
import styles from './Checkbox.module.css';

const Checkbox = React.forwardRef(function Checkbox(
  { label, checked, onChange, disabled, className, ...rest },
  ref
) {
  return (
    <label className={cn(styles.root, disabled && styles.disabled, className)}>
      <input
        ref={ref}
        type='checkbox'
        className={styles.input}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        {...rest}
      />
      <span className={styles.box} aria-hidden='true' />
      {label && <span className={styles.label}>{label}</span>}
    </label>
  );
});

Checkbox.propTypes = {
  label: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  className: PropTypes.string
};

export default Checkbox;
